import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'

export const PartInputWrapper = styled(Container)`
  flex: 1 1 0;
  min-width: 0;
`

export const UnitSelectWrapper = styled(Container)`
  flex-shrink: 0;
`

export const PartSuffix = styled(Typography)`
  white-space: nowrap;
  flex-shrink: 0;
`
